import { Suspense, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  AdminSidebar,
  AdminHeader,
  Footer,
  ScorerBottomNav,
  ScorerLiveBanner,
} from '@/components/layout';
import SideDrawer from '@/components/ui/side-drawer';
import PageLoader from '@/components/PageLoader';
import { useAuth } from '@/context';
import { useAdminBreadcrumbs } from '@/hooks';
import { ROUTES, ROLES } from '@/constants';
import { cn } from '@/lib/utils';

function AdminLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const breadcrumbs = useAdminBreadcrumbs();
  const isScorer = user?.role === ROLES.SCORER;

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <div className="flex min-h-dvh bg-background">
      <AdminSidebar
        collapsed={collapsed}
        onCollapse={() => setCollapsed((c) => !c)}
        className="sticky top-0 hidden h-dvh shrink-0 lg:flex"
      />

      <SideDrawer open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
        <AdminSidebar
          collapsed={false}
          isDrawer
          showCollapse={false}
          onNavigate={() => setMobileNavOpen(false)}
          className="h-full"
        />
      </SideDrawer>

      <div className="flex min-w-0 flex-1 flex-col">
        <AdminHeader
          user={user}
          onLogout={handleLogout}
          breadcrumbs={breadcrumbs}
          onMenuClick={() => setMobileNavOpen(true)}
          showSearch={!isScorer}
        />
        {isScorer && <ScorerLiveBanner />}
        <main
          className={cn(
            'flex-1 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] md:p-6',
            isScorer && 'pb-[calc(5.5rem+env(safe-area-inset-bottom))] lg:pb-6'
          )}
        >
          <Suspense fallback={<PageLoader message="Loading page..." />}>
            {children ?? <Outlet />}
          </Suspense>
        </main>
        {!isScorer && <Footer variant="admin" />}
      </div>

      {isScorer && <ScorerBottomNav />}
    </div>
  );
}

export default AdminLayout;
